/*!
 * Copyright (c) 2021 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

module.exports = {
  SECURITY_CONTEXT_V1_URL: 'https://w3id.org/security/v1',
  SECURITY_CONTEXT_V2_URL: 'https://w3id.org/security/v2',
  CONTEXT_URL: 'https://w3id.org/security/v2'
};
